// Remote Support HTTP API: owner-side grant management + agent-side live
// session listing. Realtime itself goes over lib/collabClient.js.

const { request } = require('./apiClient');

function listSupportAgents() {
  return request('/support-access').then(function(result) {
    return result && Array.isArray(result.data) ? result.data : [];
  });
}

// identifier = email (or username) of the Alleflow account to add.
function addSupportAgent(identifier) {
  return request('/support-access', {
    method: 'POST',
    body: { identifier: identifier }
  }).then(function(result) {
    return result && result.data ? result.data : null;
  });
}

function removeSupportAgent(agentUserId) {
  return request('/support-access/' + encodeURIComponent(agentUserId), {
    method: 'DELETE'
  });
}

// Live sessions I can join right now (owners who granted me access AND have
// a canvas open). [{ownerId, ownerUsername, workflowId, workflowName, memberCount}]
function listActiveSupportSessions() {
  return request('/support-access/active-sessions').then(function(result) {
    return result && Array.isArray(result.data) ? result.data : [];
  });
}

module.exports = {
  listSupportAgents,
  addSupportAgent,
  removeSupportAgent,
  listActiveSupportSessions
};
